//FuelPolicyAutocomplete

import React from "react"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData } from "Pages/ReportsAlerts/Reports/@signals"
import { array, object } from "yup"
import { AppConditionPriceMinMaxAutocomplete } from "@components/Autocomplete"


export default function ReportMinMaxAlertField() {
	const {
		conditionsPriceMinmax,
		setConditionsPriceMinmaxInfo,
		error
	} = useReportFormInfo(reportFormData.peek().conditionsPriceMinmax || [], "conditionsPriceMinmax", object({ conditionsPriceMinmax: array().nullable() }))

	return <AppConditionPriceMinMaxAutocomplete
		multiple
		value={conditionsPriceMinmax}
		onChange={e => setConditionsPriceMinmaxInfo(e.target.value)}
		error={error}
	/>
}